import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = URLS.URL_PRD

const getLocations = async (filters = {}) => {
  console.log('FILTERS :', filters)
  const { division, departments, line, brand, store } = filters;
  const params = {
    storeId: store?.value,
    divisionId: division?.value,
    departmentId: departments?.value,
    lineId: line?.value,
    brandId: brand?.value,
  }
  const { data } = await Axios.get(`${BASE_URL}/locations`,{
    params
  })
  console.log('data LOCATIONS: ', data.locations)
  return data.locations
}

const createLocation = async (location) => {
  // const { name, storeId, divisionId, departmentId, lineId, brandId } = location
  const { data } = await Axios.post(`${BASE_URL}/locations`,{
    location
  })
  console.log('Created LOCATION: ', data)
  return data
}

const updateLocation = async (location, id) => {
  // const { name, storeId, divisionId, departmentId, lineId, brandId } = location
  const { data } = await Axios.put(`${BASE_URL}/locations/${id}`,{
    location
  })
  console.log('Updated LOCATION: ', data)
  return data
}

const deleteLocation = async (locationId) => {
  // const { name, storeId, divisionId, departmentId, lineId, brandId } = location
  const { data } = await Axios.delete(`${BASE_URL}/locations/${locationId}`)
  console.log('Updated LOCATION: ', data)
  return data
}

const getDepartments = async (filters = {}) => {
  const { data } = await Axios.get(`${BASE_URL}/places/departments`,{
    params: filters
  })
  console.log('data Departments: ', data.departments)
  return data.departments
}

const getDivisions = async (filters = {}) => {
  const { data } = await Axios.get(`${BASE_URL}/places/divisions`,{
    params: filters
  })
  console.log('data Divisions: ', data.divisions)
  return data.divisions
}

const getLines = async (filters = {}) => {
  const { data } = await Axios.get(`${BASE_URL}/places/lines`,{
    params: filters
  })
  console.log('data Lines: ', data.lines)
  return data.lines
}

const getBrands = async (filters = {}) => {
  const { data } = await Axios.get(`${BASE_URL}/places/brands`,{
    params: filters
  })
  console.log('data Brands: ', data.brands)
  return data.brands
}

export default {
  getLocations,
  createLocation,
  updateLocation,
  deleteLocation,
  getDepartments,
  getDivisions,
  getLines,
  getBrands,
}
